import { Nav } from '../Model/Nav'
import { observable, action, computed, toJS } from 'mobx'

export interface IConfigStore {
    showLangs: boolean
}

const pageSizeKey = 'PageSize'

export interface IReportModel {
    Key: string
    AZ: string
    RU: string
}

export default class ConfigStore implements IConfigStore {

    @observable
    private pageSize: number = 15

    @action.bound
    setPageSize(pageSize: number) {
        window.localStorage.setItem(pageSizeKey, pageSize.toString())
        this.pageSize = pageSize
    }

    @computed
    get getPageSize(): number {
        let pageSize = this.pageSize

        let pageSizeFromStorage: number = parseInt(window.localStorage.getItem(pageSizeKey)!, 10)
        if (!isNaN(pageSizeFromStorage)) {
            pageSize = pageSizeFromStorage
        }
        return toJS(pageSize)
    }

    showLangs: boolean

    private _mockModeKeys: Array<string>

    get mockModeKeys() {
        return this._mockModeKeys
    }

    @observable
    private _mockMode: boolean

    get mockMode() {
        return this._mockMode
    }

    switchMockMode() {
        this._mockMode = !this._mockMode
    }

    @observable
    public toggledLeftBarClass: string

    private closedClass = 'left-menu-closed'

    toggleLeftBar(toClose?: Boolean): void {
        if (toClose) {
            this.toggledLeftBarClass = this.closedClass
            return
        }
        this.toggledLeftBarClass = this.toggledLeftBarClass.length ? '' : this.closedClass
    }

    @observable
    private _nav: Nav

    private static _instance: ConfigStore

    private _reportsIframes: Array<IReportModel> = [
        {
            'Key': 'globalReport',
            'AZ': 'https://datastudio.google.com/embed/reporting/17320196-a229-41f4-b486-37a6f3b8782c/page/URWeB',
            'RU': 'https://datastudio.google.com/embed/reporting/17320196-a229-41f4-b486-37a6f3b8782c/page/URWeB'
        },
        {
            'Key': 'categoriesReport2',
            'AZ': 'https://datastudio.google.com/embed/reporting/5e87c35c-18ae-49b5-b52b-c577cb2f060e/page/35uxB',
            'RU': 'https://datastudio.google.com/embed/reporting/5e87c35c-18ae-49b5-b52b-c577cb2f060e/page/35uxB'
        },
        {
            'Key': 'portfelSezam',
            'AZ': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/M9erB',
            'RU': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/M9erB'
        },
        {
            'Key': 'k1k2',
            'AZ': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/F3rrB',
            'RU': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/F3rrB'
        },
        {
            'Key': 'smartPhoneReport',
            'AZ': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/HUtrB',
            'RU': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/HUtrB'
        },
        {
            'Key': 'categoriesReport',
            'AZ': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/YAurB',
            'RU': 'https://datastudio.google.com/embed/reporting/5b956194-f299-4b7d-95be-041daf08125d/page/YAurB'
        },
        {
            'Key': 'dailyFlow',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/MlbmB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/MlbmB'
        },
        {
            'Key': 'grid',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/U4emB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/U4emB'
        },
        {
            'Key': 'collection',
            'AZ': 'https://datastudio.google.com/embed/reporting/14354566-72c7-4d95-9db7-b6daacc6e9a0/page/nsrmB',
            'RU': 'https://datastudio.google.com/embed/reporting/14354566-72c7-4d95-9db7-b6daacc6e9a0/page/nsrmB'
        },
        {
            'Key': 'daily',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/X3CnB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/X3CnB'
        },
        {
            'Key': 'profitAndStatuses',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/M9SnB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/M9SnB'
        },
        {
            'Key': 'profitAndStatusesByDays',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/TdenB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/TdenB'
        },
        {
            'Key': 'sourcesAndTypes',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/SHknB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/SHknB'
        },
        {
            'Key': 'sourcesAndTypesByDates',
            'AZ': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/4sonB',
            'RU': 'https://datastudio.google.com/embed/reporting/1aacf710-33c9-4779-9607-eb6991ce1f86/page/4sonB'
        },
       
        {
            'Key': 'audienceProductPopularity',
            'AZ': 'https://datastudio.google.com/embed/reporting/1xrCqmXQB5uslUi-YYT59W2QlUFPIMeZM/page/r1al',
            'RU': 'https://datastudio.google.com/embed/reporting/1WUuweIjpD46I316Sfyhv9ZTlFn-ASpDr/page/r1al'
        },
        {
            'Key': 'audienceProductPopularityTable',
            'AZ': 'https://datastudio.google.com/embed/reporting/1xrCqmXQB5uslUi-YYT59W2QlUFPIMeZM/page/bull',
            'RU': 'https://datastudio.google.com/embed/reporting/1WUuweIjpD46I316Sfyhv9ZTlFn-ASpDr/page/bull'
        },
        {
            'Key': 'audienceQuestionnaires',
            'AZ': 'https://datastudio.google.com/embed/reporting/1xrCqmXQB5uslUi-YYT59W2QlUFPIMeZM/page/ogdl',
            'RU': 'https://datastudio.google.com/embed/reporting/1WUuweIjpD46I316Sfyhv9ZTlFn-ASpDr/page/ogdl'
        },
        {
            'Key': 'audienceReview',
            'AZ': 'https://datastudio.google.com/embed/reporting/1xrCqmXQB5uslUi-YYT59W2QlUFPIMeZM/page/bVej',
            'RU': 'https://datastudio.google.com/embed/reporting/1WUuweIjpD46I316Sfyhv9ZTlFn-ASpDr/page/bVej'
        },
        {
            'Key': 'creditExpertsKPI',
            'AZ': 'https://datastudio.google.com/embed/reporting/1NZjQZ0aW6mnoxYVNS5pr2fWQSOiWyGux/page/LbJl',
            'RU': 'https://datastudio.google.com/embed/reporting/1ewD0bG1XdbbZJ0ZnZtwCcy3yCNwvMYuB/page/LbJl'
        },
        {
            'Key': 'creditСonsultantsKPI',
            'AZ': 'https://datastudio.google.com/embed/reporting/1NZjQZ0aW6mnoxYVNS5pr2fWQSOiWyGux/page/aOuk',
            'RU': 'https://datastudio.google.com/embed/reporting/1ewD0bG1XdbbZJ0ZnZtwCcy3yCNwvMYuB/page/aOuk'
        },
        {
            'Key': 'geographyProductPopularity',
            'AZ': 'https://datastudio.google.com/embed/reporting/1xrCqmXQB5uslUi-YYT59W2QlUFPIMeZM/page/Xxll',
            'RU': 'https://datastudio.google.com/embed/reporting/1WUuweIjpD46I316Sfyhv9ZTlFn-ASpDr/page/Xxll'
        },
        {
            'Key': 'geographyQuestionnaires',
            'AZ': 'https://datastudio.google.com/embed/reporting/1xrCqmXQB5uslUi-YYT59W2QlUFPIMeZM/page/tgdl',
            'RU': 'https://datastudio.google.com/embed/reporting/1WUuweIjpD46I316Sfyhv9ZTlFn-ASpDr/page/tgdl'
        },
        {
            'Key': 'productsStatistics',
            'AZ': 'https://datastudio.google.com/embed/reporting/1AApunuaCYCOT53ThDLpM6TC9FbtHxxn1/page/AVEk',
            'RU': 'https://datastudio.google.com/embed/reporting/14sgnt9onwW94_Q4qdpITO3voK-uG884z/page/AVEk'
        },
        {
            'Key': 'questionnairesStatistics',
            'AZ': 'https://datastudio.google.com/embed/reporting/1AApunuaCYCOT53ThDLpM6TC9FbtHxxn1/page/D2Jl',
            'RU': 'https://datastudio.google.com/embed/reporting/14sgnt9onwW94_Q4qdpITO3voK-uG884z/page/D2Jl'
        },
        {
            'Key': 'troubleEventsStatistics',
            'AZ': 'https://datastudio.google.com/embed/reporting/1AApunuaCYCOT53ThDLpM6TC9FbtHxxn1/page/zkdl',
            'RU': 'https://datastudio.google.com/embed/reporting/14sgnt9onwW94_Q4qdpITO3voK-uG884z/page/zkdl'
        },
        {
            'Key': 'reportDashboard',
            'AZ': 'https://datastudio.google.com/embed/reporting/63d5d9f5-74e0-4ee7-afbb-863d98a3e2af/page/8yC3B',
            'RU': 'https://datastudio.google.com/embed/reporting/63d5d9f5-74e0-4ee7-afbb-863d98a3e2af/page/8yC3B'
        },
        {
            'Key': 'reportPortfolioB',
            'AZ': 'https://datastudio.google.com/embed/reporting/0215ba20-87f9-48ce-8d1f-26c086a293f2/page/M9erB',
            'RU': 'https://datastudio.google.com/embed/reporting/0215ba20-87f9-48ce-8d1f-26c086a293f2/page/M9erB'
        }
       
    ]

    get getReportsIframes(): Array<IReportModel> {
        return this._reportsIframes
    }

    private constructor() {
        this.showLangs = true
        this._mockMode = false
        this._mockModeKeys = ['ctrl + shift + `']
        this.toggledLeftBarClass = this.closedClass
        this._nav = Nav.getInstance()
    }

    public static getInstance(): ConfigStore {
        return this._instance || (this._instance = new this())
    }

    get nav() {
        return this._nav
    }

    get getLeftBarToggled() {
        return window.localStorage.getItem('LeftBarToggled')
    }

    setLeftBarToggled() {
        let toggled = window.localStorage.getItem('LeftBarToggled')
        window.localStorage.setItem('LeftBarToggled', 'true' === toggled ? 'false' : 'true')
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/ConfigStore.tsx